export default __webpack_public_path__ + "static/media/queEsVedi.987a109b.png";